import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  appContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;
